import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Moment from 'react-moment';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  containerTable: {
    backgroundColor: 'white',
    width: 'auto',
    margin: '10px',
    padding: '5px',
    border: '1px solid  rgba(0,0,0,0.2)',
    borderRadius: '5px',
    scrollbarWidth: '8px',
    scrollbarColor: '#f1f1f1',
    '&::-webkit-scrollbar': {
      width: '8px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
      borderRadius: '4px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#b2b2b2',
      borderRadius: '4px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#555'
    }
  },
  status: {
    color: 'green',
    fontWeight: 'bold'
  },
  datetime: {
    cursor: 'pointer',
    '&:hover': {
      color: 'blue',
      textDecoration: 'underline'
    }
  },
  th: {
    fontWeight: 'bold'
  },
  containerStatus: {
    display: 'flex',
    alignItems: 'center'
  },
  iconStatus: {
    marginRight: '5px'
  },
  downloadLink: {
    cursor: 'pointer',
    color: 'green',
    fontWeight: 'bold',
    '&:hover': {
      color: 'green',
      textDecoration: 'underline'
    }
  }
});

const renderStatus = {
  generating: { color: 'orange', fontWeight: 'bold' },
  error: { color: 'red', fontWeight: 'bold' }
};

export default function ListExportData ({ data }) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <TableContainer className={classes.containerTable}>
      <Table size='small' aria-label='a dense table'>
        <TableHead>
          <TableRow>
            <TableCell className={classes.th}>{t('exportData:requested')}</TableCell>
            <TableCell className={classes.th}>{t('exportData:filters')}</TableCell>
            <TableCell className={classes.th}>{t('exportData:status')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data === null && <TableRow>
            <TableCell colSpan={3} style={{ textAlign: 'center' }}>{t('exportData:loading') }</TableCell>
          </TableRow>}
          {data && data.length === 0 && <TableRow>
            <TableCell colSpan={3} style={{ textAlign: 'center' }}>{t('exportData:noData') }</TableCell>
          </TableRow>}
          {data && data.length > 0 && data.map((row) => (
            <TableRow key={row.createdAt}>
              <TableCell >
                { row.downloadLink === 'generating'
                  ? <Moment format='DD/MM/YYYY HH:mm:ss' >{row.createdAt}</Moment>
                  : <Moment className={classes.datetime} onClick={() => window.open(row.downloadLink, '_blank')} format='DD/MM/YYYY HH:mm:ss' >
                    {row.createdAt}
                  </Moment>
                }
              </TableCell>
              <TableCell>
                {row.filters.map(([key, value]) => (
                  <div key={key}>
                    <span>{t(`exportData:${key}`)}: </span>
                    <span style={{ fontWeight: 'bold' }} >{value}</span>
                  </div>
                ))}
              </TableCell>
              <TableCell >
                { row.status === 'ready' && <div className={classes.containerStatus}>
                  <div className={classes.iconStatus}>
                    <CheckCircleIcon style={{ color: 'green' }} />
                  </div>
                  <div>
                    <div>
                      {t(`exportData:${row.status}`)}
                    </div>
                    <div className={classes.downloadLink} onClick={() => window.open(row.downloadLink, '_blank')}>
                      {t('exportData:download')}
                    </div>
                  </div>
                </div>
                }
                { row.downloadLink === 'generating' &&
                  <div style={renderStatus[row.status]}>
                    {t(`exportData:${row.status}`)}
                  </div>
                }
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ListExportData.propTypes = {
  data: PropTypes.array
};
